import http from '../utils/http-common'

const getAll = (param) => {
  return http.get('/salutations', { params: param })
}

const SalutationDataService = {
  getAll,
}
export default SalutationDataService
